// extracted by mini-css-extract-plugin
module.exports = {"pasta":"Pasta_pasta__2NtcS","pastaRemoving":"Pasta_pastaRemoving__1KpTL","pastaPaused":"Pasta_pastaPaused__133IT"};